import {
	API_ENDPOINTS,
	customToast,
	route,
	Variants,
} from 'carrier-fe';
import axios from 'axios';

interface ExportClaimsOptions {
	claimIds: string[];
	fallbackFilename: string;
	successMessage: string;
}

async function exportClaims({
	claimIds,
	fallbackFilename,
	successMessage,
}: ExportClaimsOptions): Promise<void> {
	const response = await axios.post(
		route(API_ENDPOINTS.ADMIN.CLAIM.EXPORT),
		{ claim_ids: claimIds },
		{ responseType: 'blob' }
	);

	const filename =
		response.headers['content-disposition']
			?.split('filename=')[1]
			?.replace(/["']/g, '') || fallbackFilename;

	const url = window.URL.createObjectURL(new Blob([response.data]));
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', filename);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);

	customToast({
		title: successMessage || 'Success. Data for claim has been exported.',
		variant: Variants.Success,
	});
}

export default exportClaims;
